module.exports = __webpack_public_path__ + "static/media/edit.1949d185.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/ServiceIcons/edit.svg
// module id = 1210
// module chunks = 0